import Check from '../Check';
import Report from '../Report';
import { MessageType } from '../Message';
import type { IEventType } from '../../../stores/model/metamodel/event_type';

/**
 * Check if an event type is used by at least one object type.
 *
 * An event type with no methods is not owned, acquired, inherited, or
 * specialised by any object type, which shows up in the Object-Event Table
 * as an empty row. The model stays structurally valid in that state, so this
 * only ever raises a warning, never an error.
 *
 * This applies uniformly to normal and specialised event types: a
 * specialised event type is created specifically so some object type(s) can
 * own a method for it, so if it ends up without any methods it is just as
 * unused as a normal event without methods (its own OET row is still empty,
 * regardless of whether the event it specialises is used elsewhere).
 */
class UnusedEventCheck extends Check<IEventType> {
  static description = 'Check for unused events';

  check(): Report {
    this.report = new Report();

    if (this.element.methods.length === 0) {
      this.report.addMessage(
        MessageType.WARNING,
        `Event ${this.element.name} is not used by any object type.`,
        this,
        this.element
      );
    } else {
      this.report.addMessage(
        MessageType.INFORMATION,
        `Event ${this.element.name} is used by at least one object type.`,
        this,
        this.element
      );
    }

    return this.report;
  }
}

export default UnusedEventCheck;
